'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MockedFooter = require('./components/MockedFooter');

var _MockedFooter2 = _interopRequireDefault(_MockedFooter);

var _CleanLoader = require('./components/CleanLoader');

var _CleanLoader2 = _interopRequireDefault(_CleanLoader);

var _EEScripts = require('../components/EEScripts');

var _EEScripts2 = _interopRequireDefault(_EEScripts);

var _EEStyles = require('../components/EEStyles');

var _EEStyles2 = _interopRequireDefault(_EEStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultLayout = function (_React$PureComponent) {
  _inherits(DefaultLayout, _React$PureComponent);

  function DefaultLayout(props) {
    _classCallCheck(this, DefaultLayout);

    // eslint-disable-next-line no-throw-literal
    var _this = _possibleConstructorReturn(this, (DefaultLayout.__proto__ || Object.getPrototypeOf(DefaultLayout)).call(this, props));

    if (!window.EEContext) {
      throw 'EEContext is undefined!';
    }

    document.body.classList.add('body');
    return _this;
  }

  _createClass(DefaultLayout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var lobCode = this.props.lobCode;

      document.querySelector('html').setAttribute('ee-current-lob-code', lobCode);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          includeCSS = _props.includeCSS,
          includeJS = _props.includeJS,
          inheritCorpoStyle = _props.inheritCorpoStyle,
          children = _props.children,
          isWider = _props.isWider,
          themeVersion = _props.themeVersion;
      var theme = window.EEContext.experience.theme;


      return _react2.default.createElement(
        _CleanLoader2.default,
        null,
        includeJS ? _react2.default.createElement(_EEScripts2.default, null) : null,
        includeCSS ? _react2.default.createElement(_EEStyles2.default, { themeVersion: themeVersion }) : null,
        _react2.default.createElement(
          'div',
          { className: 'we_pageContainer' + (isWider ? ' wider' : '') },
          _react2.default.createElement('ee-header', null),
          _react2.default.createElement(
            'div',
            { className: inheritCorpoStyle ? 'basepagelayout-content' : undefined },
            _react2.default.createElement(
              'div',
              { className: inheritCorpoStyle ? 'we_container' : undefined, style: { borderBottom: theme.toLowerCase() === "tbn" ? '2rem solid #484a4b' : '2rem solid #003ba9' } },
              children
            )
          ),
          window.EEContext.isLocal ? _react2.default.createElement(_MockedFooter2.default, null) : _react2.default.createElement('ee-footer', null)
        )
      );
    }
  }]);

  return DefaultLayout;
}(_react2.default.PureComponent);

DefaultLayout.defaultProps = {
  includeJS: true,
  includeCSS: true,
  isWider: false,
  inheritCorpoStyle: true
};

DefaultLayout.propTypes = {
  includeJS: _propTypes2.default.bool,
  includeCSS: _propTypes2.default.bool,
  isWider: _propTypes2.default.bool,
  inheritCorpoStyle: _propTypes2.default.bool,
  themeVersion: _propTypes2.default.string,
  lobCode: _propTypes2.default.string,
  children: _propTypes2.default.any.isRequired
};

exports.default = DefaultLayout;